require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconClose.tsx
var IconClose_exports = {};
__export(IconClose_exports, {
  default: () => IconClose_default
});
module.exports = __toCommonJS(IconClose_exports);

// src/assets/monochrome/close.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgClose = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.07915 3.0771C3.42086 2.73539 3.97488 2.73539 4.31659 3.0771L10.0014 8.76188L15.6851 3.07818C16.0268 2.73647 16.5808 2.73647 16.9225 3.07818C17.2642 3.41989 17.2642 3.97391 16.9225 4.31562L11.2388 9.99932L16.9232 15.6837C17.2649 16.0254 17.2649 16.5794 16.9232 16.9211C16.5815 17.2628 16.0275 17.2628 15.6858 16.9211L10.0014 11.2368L4.31591 16.9222C3.9742 17.2639 3.42018 17.2639 3.07847 16.9222C2.73676 16.5805 2.73676 16.0265 3.07847 15.6848L8.76393 9.99932L3.07915 4.31454C2.73744 3.97283 2.73744 3.41881 3.07915 3.0771Z", fill: "#676F7E" }) });
var close_default = SvgClose;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconClose.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconClose = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(close_default, {}) });
};
IconClose.displayName = "IconClose";
var IconClose_default = IconClose;
